import { useForm } from "react-hook-form";
import z from "zod";
import { MiControlledTextField, MiModal } from "@miplatform/components";
import { ButtonVariants, Colors } from "@miplatform/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { mdiAccountLockOpen } from "@mdi/js";
import { useTheme } from "@mui/material";

const schema = z.object({
  reason: z.string().min(1, "Reason is required"),
});

interface WorkOrderForceReleaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRelease: (reason: string) => void;
}
export const WorkOrderForceReleaseModal = ({
  isOpen,
  onClose,
  onRelease,
}: WorkOrderForceReleaseModalProps) => {
  const theme = useTheme();
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: { reason: "" },
    resolver: zodResolver(schema),
  });

  return (
    <MiModal
      open={isOpen}
      closeModal={onClose}
      width={448}
      actions={[
        {
          name: "Cancel",
          onClick: onClose,
          variant: ButtonVariants.Text,
          color: Colors.Black,
        },
        {
          variant: ButtonVariants.Contained,
          color: Colors.Primary,
          name: "Force Release",
          onClick: handleSubmit((data) => onRelease(data.reason)),
          disabled: !isValid,
        },
      ]}
      title="Force Release Work Order"
      titleIcon={mdiAccountLockOpen}
      leftIconColor={theme.palette.deepPurple.medium}
      description="Force releasing will allow for the work order to be re-assigned by a manager."
    >
      <MiControlledTextField
        required
        label="Reason"
        formControl={control}
        name="reason"
      />
    </MiModal>
  );
};
